export default __webpack_public_path__ + "static/mein-konzept-c51ab39412d9c9660cf621e815be66d6.png";